import { GroupDetailsPage } from 'features/groups';

export const TechOperatorGroupDetailsPage: React.FC = () => (
  <GroupDetailsPage />
);
